import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { commerceCartAddProduct, UI_OPERATION_STATUS_ERROR } from '@uncinc/react-drupal-core';
import { QuantityPicker } from 'react-qty-picker';
import { Button, Container, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../../helpers/commerce';

import WysiwygField from '../../../../components/WysiwygField';

import '../style.scss';

const ParagraphProduct = ({ entity }) => {
  const dispatch = useDispatch();

  const [quantity, setQuantity] = useState(1);
  const [variationIndex, setVariationIndex] = useState(0);
  const { t } = useTranslation();
  const pageViewSent = useSelector((state) => state.getIn(['uiInternal', 'pageViewSent'], false));

  const productAddStatus = useSelector((state) => state.getIn(['ui', 'commerce', 'operations', 'cart_product_add', 'status']));
  const status = entity.getIn(['field_product', 0, 'entity', 'status', 0, 'value'], false);
  const title = entity.getIn(['field_product', 0, 'entity', 'title', 0, 'value'], '');
  const variationPrice = entity.getIn(['field_product', 0, 'entity', 'variations', variationIndex, 'price', 'number']);
  const sku = entity.getIn(['field_product', 0, 'entity', 'variations', variationIndex, 'sku']);
  /* below is a plain text body field, hence 'value' */
  const body = entity.getIn(['field_product', 0, 'entity', 'body', 0, 'value'], '');
  const hasMultipleVariations = entity.getIn(['field_product', 0, 'entity', 'variations']).size > 1;
  const minimumQuantity = 1;
  const maximumQuantity = entity.getIn(['field_product', 0, 'entity', 'variations', variationIndex, 'maximum_quantity'], 10);

  useEffect(() => {
    if (window && pageViewSent) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'EUR',
          value: variationPrice,
          items: [
            {
              item_id: sku,
              item_name: title,
              price: variationPrice,
              quantity: quantity
            }
          ]
        }
      });
    }
  }, [pageViewSent]);

  const onOrderClick = () => {
    dispatch(commerceCartAddProduct(entity.getIn(['field_product', 0, 'entity', 'variations', variationIndex, 'target_uuid']), quantity));

    if (window) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        productName: title,
        productPrice: variationPrice,
        productQuantity: quantity,
        productSku: sku,
        ecommerce: {
          currency: 'EUR',
          value: variationPrice * quantity,
          items: [
            {
              item_id: sku,
              item_name: title,
              price: variationPrice,
              quantity: quantity
            }
          ]
        }
      });
    }
  };

  const onVariationChange = (index) => {
    if (!index) {
      index = 0;
    }
    setVariationIndex(index);
  };

  return (
    <Container className="Paragraph Product ParagraphProduct">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <div className="ParagraphCTA">
            <div className="ParagraphCTA__inner Product__inner">
              <div className="ParagraphCTA__body Product__body">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-12 col-xl-6">
                    <h3 className="Product__title">{title}</h3>
                    <WysiwygField
                      className="Product__description subheading2"
                      property="schema:text"
                      html={body}
                    />
                  </div>
                  <div className={classNames('Product__wrapper col-12 col-md-6 col-lg-12 col-xl-6', { variant: hasMultipleVariations })}>
                    <h3 className="Product__Price">&euro; {formatPrice(variationPrice)} <span>excl. BTW en evt. verzendkosten</span></h3>
                    {hasMultipleVariations && (
                      <FormikWrapper>
                        <Select
                          required
                          placeholder="Kies een variant"
                          fieldName="product_variation"
                          options=""
                          onChange={onVariationChange}
                        />
                      </FormikWrapper>
                    )}

                    <div className="Product__orderBar">
                      <QuantityPicker min={minimumQuantity} max={maximumQuantity} value={quantity} onChange={(value) => setQuantity(value)} width="2rem" />
                      {status ? (
                        <Button
                          to="#"
                          className="Button--primary Button--order"
                          onClick={onOrderClick}
                        >
                          Bestellen
                          <div className="icon icon-shopping-cart icon-variant-2" />
                        </Button>
                      ) : (
                        <Button
                          to="#"
                          className="Button--primary Button--order"
                          disabled
                        >
                          Tijdelijk niet bestelbaar
                        </Button>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    {(productAddStatus === UI_OPERATION_STATUS_ERROR) && (
                      <div className="Product__product__error Form__error">{t('cart.maximum_quantity_limit_reached', { maximumQuantity })}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphProduct;
